// extracted by mini-css-extract-plugin
module.exports = {"sidebarContainer":"hTFVVll2"};